import styled from 'styled-components';
import { DESKTOP_MIN_BREAK, GTM_DATA_ATTRIBUTE } from '#/shared/constants';
import GTM_HANDLES from '#/shared/gtm-handles';
import { ClearLink } from '#/shared/components/Styled';

// The wrapper ensures that we back this with the appropriate color
export const AlertListWrapper = styled.div`
  background-color: ${props => props.theme.inverseBackgroundColor1};
  color: ${props => props.theme.inverseFontColor1};
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  overflow-y: auto;
`;

export const AlertListHeader = styled.div`
  display: flex;
  padding: 28px;
  max-width: ${DESKTOP_MIN_BREAK};
  justify-content: center;
`;

export const AlertListBody = styled.ul`
  color: ${props => props.theme.inverseFontColor1};
  display: flex;
  flex-direction: column;
  max-width: ${DESKTOP_MIN_BREAK};
  margin-bottom: 5px;
  padding: 0 8px;
`;

export const AlertRow = styled.li`
  display: flex;
  margin-bottom: 12px;
  padding-bottom: 12px;
`;

export const AlertIconColumn = styled.div`
  flex: 0 0 45px;
  display: flex;
  justify-content: center;
`;

export const AlertDetailColumn = styled.div`
  flex: 1 1 auto;
  padding: 0 10px;
`;

export const AlertContent = styled.div`
  font-size: 1.1em;
  line-height: 1.4em;
`;

export const AlertTimestamp = styled.div`
  font-size: 0.8em;
  color: ${props => props.theme.inverseFontColor2};
  font-weight: 400;
`;

export const AlertMoreLink = styled(ClearLink).attrs({
  target: '_blank',
  [GTM_DATA_ATTRIBUTE]: GTM_HANDLES.routeAlerts.moreLink,
})`
  color: ${props => props.theme.inverseFontColor2};
  margin-left: 0.2em;

  &:not(:hover) {
    text-decoration: underline;
  }
`;
